import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import IsProdEnvironment from '~/app/utils/is-production-environment';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: [
		'electricRangeCombined',
		'maxPower',
		'speed',
		'acceleration',
		'consumption',
		'chargingTime',
		'classCO2',
	],
	showEECLabel: true,
	wltpInfo: {
		url: {
			url: `https://mediaservice.audi.com/media/b2c/v6-common/img-HEAD.zip/v6/eec-lu/lu-{{language}}/eec-label-0.png`,
			pathParams: {},
			queryParams: [],
		},
		energyClass: '0',
	},
	enableFinancingServices: !IsProdEnvironment(),
	hideMonthlyRates: IsProdEnvironment(),
	financeDomain: 'AUDI.LU',
	enablePriceDisclaimer: true,
	nextBestActions: [
		{
			icon: '',
			description: 'Schauen Sie sich unsere verfügbaren Fahrzeuge an',
			labelText: 'Verfügbare Fahrzeuge',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.lu/de/web/{{language}}/new-cars-search/ergebnisse.html#filter=carline.{{carlineId}} ',
		},
		{
			icon: 'send',
			description: 'Kontaktieren Sie Ihren Audi Händler',
			labelText: 'Kontakt zu einem Händler',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://marketing.losch.lu/onlinebooking/audi/index.html',
		},
		{
			icon: 'test-drive',
			description: 'Vereinbaren Sie eine Probefahrt mit Ihrem neuen Audi',
			labelText: 'Probefahrt vereinbaren',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://marketing.losch.lu/forms/requests/de/audi/index.html',
		},
	],
	summaryFooterCta: {
		icon: 'code',
		description: 'Audi Code',
		labelText: 'Audi Code',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
};
